import React, { useRef, useEffect, useState,useMemo  } from 'react';
import { getAllStudents,getBatches,getAllBatchStudents, getAllBatchAndReportTypeStudents } from '../../services/studentService';
import { Link } from "react-router-dom";
import "./datatable.scss"
import { DataGrid } from '@mui/x-data-grid';
import axiosInstance from '../../api/axios';
import { toast } from 'react-toastify';


export const StudentList=()=> {
    const fileInputRef = useRef(null);
    const [students, setStudents] = useState([]);
    const [enrollmentMap, setEnrollmentMap] = useState({});
    const [batches, setBatches] = useState([]);
    const [batchValue, setBatchValues] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [file, setFile] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [reportType, setReportType] = useState("");


    const fetchEnrollmentMap = async () => {
        try {
            const res = await axiosInstance.get('/getAllEnrollments');
            const enrollments = res.data?.data || [];
            const map = {};
            enrollments.forEach(e => {
                if (!map[e.studentId] || e.status === 'ACTIVE') {
                    map[e.studentId] = {
                        enrolledDegree: e.degreeName || '',
                        enrolledProgram: e.programName || '',
                    };
                }
            });
            setEnrollmentMap(map);
        } catch {
            // non-fatal: enrollment columns just stay empty
        }
    };

    const fetchStudents = async () => {
        try {
            const data = await getAllStudents();
            setStudents(data.data);

            const batchdata= await getBatches();
            setBatches(batchdata.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchBatchStudents = async (batch) => {
        try {
            const data = await getAllBatchStudents(batch);
           // console.log(data);
            
            setStudents(data.data);


        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchReportTypeStudents = async (batch,reportType) => {
        try {
            const data = await getAllBatchAndReportTypeStudents(batch,reportType);
            console.log(data);
            
            setStudents(data.data);


        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStudents();
        fetchEnrollmentMap();
    }, []);
    
    const [visibility, setVisibility] = useState(
        students.reduce((acc, row) => {
            acc[row.id] = false; // Assuming each row has a unique 'id' field
            return acc;
        }, {})
    );

    // Toggle visibility for a specific row
    const togglePasswordVisibility = (id) => {
        setVisibility(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));
    };
    
    const columns = useMemo(() => [
            { field: 'enrollmentNumber', headerName: 'Enrollment No.', width: 150 },
            { field: 'name', headerName: 'Name', width: 150 },
            { field: 'password', headerName: 'Login Password', width: 200, renderCell: (params) => (
                <div>
                    {visibility[params.row.id] ? params.value : '********'}
                    <button onClick={() => togglePasswordVisibility(params.row.id)}>
                        {visibility[params.row.id] ? ' Hide ' : ' Show '}
                    </button>
                </div>
            ) },
            { field: 'dob', headerName: 'DOB', width: 120 },
            { field: 'email', headerName: 'Email', width: 180 },           
            { field: 'contactNumber', headerName: 'Contact No.', width: 120 },
            { field: 'enrolledDegree', headerName: 'Enrolled Degree', width: 150 },
            { field: 'enrolledProgram', headerName: 'Enrolled Program', width: 180 },
        ], [visibility]);
   
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const actionColumn = [{ field: "action", headerName:"Action", width:200,
        renderCell:(params)=>{
            const { id } = params.row;
            return(
                <div className="cellAction">
                    <div className="viewButton">View</div>
                    <div className="editButton"><Link to={{pathname: `/students/edit-student/${id}`}} style={{textDecoration:"none" }}>Edit</Link></div>
                </div>
            );
        }
    }]

   

    const handleFileChange = (event) => {
        setFile(null);
        const selectedFile = event.target.files[0];
        const maxFileSize = 10 * 1024 * 1024; // 10 MB
        const allowedTypes = [
          //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
          //'application/vnd.ms-excel', // .xls
          'text/csv' // .csv
        ];

        if (selectedFile && selectedFile.size > maxFileSize) {
          toast.error('File size exceeds 10 MB limit');
          event.target.value='';
          return;
        }

        else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
          //toast.error('Only Excel (.xlsx, .xls) and CSV (.csv) files are allowed');
          toast.error('Only CSV (.csv) files are allowed');
          event.target.value='';
          return;
        }
        else{
            setFile(selectedFile);
        }
       
    };

    const handleBatchChange = (event) => {
        const value = event.target.value;
        setBatchValues(value);

        // If batch cleared
        if (!value) {
            if (reportType) {
                // Filter only by report type
                fetchReportTypeStudents(null, reportType);
            } else {
                // No filters
                fetchStudents();
            }
            return;
        }

        // If batch selected but no report type
        if (value && !reportType) {
            fetchBatchStudents(value);
            return;
        }

        // If both filters selected
        if (value && reportType) {
            fetchReportTypeStudents(value, reportType);
            return;
        }
    };

    const handleReportTypeChange = (event) => {
        const value = event.target.value;
        setReportType(value);

        // If reportType is cleared (All Report Types)
        if (!value) {
            if (batchValue) {
                // Filter only by batch
                fetchBatchStudents(batchValue);
            } else {
                // No filters
                fetchStudents();
            }
            return;
        }

        // If only reportType selected
        if (value && !batchValue) {
            fetchReportTypeStudents(null, value);
            return;
        }

        // If both filters selected
        if (value && batchValue) {
            fetchReportTypeStudents(batchValue, value);
            return;
        }
    };



    const handleSubmit = async (event) => {
        event.preventDefault();
        if(file==null){
            toast.error('Please select file');
            return;
        }
            
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axiosInstance.post('/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                showToastOnResponse: true
            });

            //console.log(response.data); 
            fetchStudents();// Handle success response
            setFile(null);
            if (fileInputRef && fileInputRef.current) {
                fileInputRef.current.value = '';
              }
        } catch (error) {
            console.error('Error uploading file:', error);
            setFile(null);
            if (fileInputRef && fileInputRef.current) {
                fileInputRef.current.value = '';
            }
           // console.log(error.response.data) // Handle error response
            if(error && (!error.response ||!error.response.data)){                
                toast.error('Uploaded file changed. Please select file again');
            }
           
            
        }
    }; 
    return (
        <div className="datatable" >
        <div className="datatableTitle">
        <div className="import">
          Import Students
         <form onSubmit={handleSubmit}>
            <input type="file"  ref={fileInputRef} onChange={handleFileChange} />
            <button type="submit">Upload File</button>
          </form>

         </div>

         <div className="formInput">
            <label>Select Batch </label>
            <select id="styled-dropdown"  
            name="batch"
            value={batchValue}
            onChange={handleBatchChange}
            >
                <option value="">All Batches</option>
                {batches && batches.map(option => (
                                                <option key={option} value={option}>
                                                    {option}
                                                </option>
                                            ))}
            </select>
            
        </div>

        <div className="formInput">
            <label>Select Report Type</label>
            <select
                id="styled-dropdown"
                name="reportType"
                value={reportType}
                onChange={handleReportTypeChange}
            >
                <option value="">All Report Types</option>

                {/* Manually added report types */}
                <option value="Projectparticular">Project Particular</option>
                <option value="Projectproposal">Project Proposal</option>
                <option value="Phase1">Phase 1</option>
                <option value="Phase2">Phase 2</option>
                <option value="Phase3">Phase 3</option>
            </select>
        </div>

        </div>
      
      <DataGrid
      rows={students.map(s => ({
          ...s,
          enrolledDegree: enrollmentMap[s.id]?.enrolledDegree || '',
          enrolledProgram: enrollmentMap[s.id]?.enrolledProgram || '',
      }))}
      columns={columns.concat(actionColumn)}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[5, 10]}
      //checkboxSelection
    />
  </div>
    );
}

